import { action } from 'mobx';
import { useStaticRendering } from 'mobx-react';
import Axios from 'axios';
import ApiCore from '../../stores/ApiCore';
const isServer = !process.browser;
useStaticRendering(isServer);

class MailerStore {
  @action send = params =>
    new Promise(resolve => {

      Axios.post('https://thinkvirtues.com/api/keap-contact', {email: params.email, phone: params.phone ? params.phone : ""})
      Axios.post(`${process.env.MAILER_URL}`, params).then(() =>
      resolve()
     );
    });
}

let mailerStore = null;

export default function initializeMailerStore(initialData) {
  if (isServer) {
    return new MailerStore(isServer, initialData);
  }

  if (mailerStore === null) {
    mailerStore = new MailerStore(isServer, initialData);
  }
  return mailerStore;
}
